
// Global State to open Buy Credit Product Menu
export const IS_BUY_CREDIT_MENU_TOGGLE = "IS_BUY_CREDIT_MENU_TOGGLE"
